//import { Articulo } from '../articulo/articulo.interface';

export class ArtImg{// implements Articulo{
	id;
	idArt;
	pagina;
	imagen;
	categoriaArticulo;
	fechModificado;
	usrModificado;

	constructor(
		id=false,
		idArt=false,
		pagina=false,
		imagen=false,
		categoriaArticulo=false,
		fechModificado=false,
		usrModificado=false
		){
		this.id = id;
		this.idArt = idArt;
		this.pagina = pagina;
		this.categoriaArticulo = categoriaArticulo;
		this.fechModificado = fechModificado;
		this.usrModificado = usrModificado;
		this.imagen = imagen;
	}

	setCategoriaArticulo(categoriaArticulo){
		this.categoriaArticulo = categoriaArticulo;
	}
}